(() => {
  'use strict';
  const offer = document.querySelector('[data-favorites-offer]');
  const popup = document.querySelector('[data-favorites-offer-popup]');
  const panel = document.querySelector('[data-saved-books]');
  if (!offer || !popup || !panel || !window.WonderbookFavorites) return;
  const key = 'wonderbook:favorites-offer:v1:sec0v0-1n.myshopify.com';
  const visitKey = key + ':visit';
  let local, session, state, timer, requestVersion = 0, eligibleTimer, ready = false;
  try {
    local = window.localStorage; session = window.sessionStorage;
    state = JSON.parse(local.getItem(key) || 'null');
    if (!state || !/^[a-f0-9]{64}$/.test(state.visitor || '')) {
      const bytes = new Uint8Array(32); window.crypto.getRandomValues(bytes);
      state = { visitor: [...bytes].map(b => b.toString(16).padStart(2, '0')).join(''), shows: 0 };
    }
  } catch (_) { return; }
  const persist = () => {
    try {
      const current = JSON.parse(local.getItem(key) || '{}');
      if (current.visitor === state.visitor) state.shows = Math.max(Number(current.shows) || 0, Number(state.shows) || 0);
      local.setItem(key, JSON.stringify(state)); return true;
    } catch (_) { return false; }
  };
  const hide = () => { ready = false; offer.hidden = true; popup.hidden = true; };
  const books = () => window.WonderbookFavorites.list().map(b => String(b.productId)).sort();
  const showReminder = () => {
    if (!ready || panel.open || document.hidden || document.querySelector('dialog[open]') || document.body.classList.contains('cart-drawer-open')) return;
    try {
      const latest = JSON.parse(local.getItem(key) || '{}');
      state.shows = Math.max(Number(latest.shows) || 0, Number(state.shows) || 0);
      if (state.shows >= 3 || session.getItem(visitKey)) return;
      state.shows += 1;
      if (!persist()) return;
      session.setItem(visitKey, 'shown');
      popup.hidden = false;
    } catch (_) { /* No reminder when the visit cap cannot be persisted. */ }
  };
  async function check() {
    const version = ++requestVersion;
    const ids = books();
    hide(); clearTimeout(eligibleTimer);
    if (state.used) return;
    if (!ids.length && !state.tracked) return;
    if (ids.length) { state.tracked = true; if (!persist()) return; }
    try {
      const params = new URLSearchParams({visitor: state.visitor, products: ids.join(',')});
      const response = await fetch('/apps/favorites-offer?' + params.toString(), {cache: 'no-store', signal: AbortSignal.timeout(15000)});
      if (!response.ok) return;
      const result = await response.json();
      if (version !== requestVersion || JSON.stringify(ids) !== JSON.stringify(books())) return;
      if (result.state === 'used') { state.used = true; persist(); return; }
      if (result.state === 'waiting') {
        const wait = Date.parse(result.eligibleAt) - Date.now();
        if (wait > 0 && wait <= 2147483000) eligibleTimer = setTimeout(check, wait + 2500);
        return;
      }
      if (result.state !== 'active' || !ids.length || result.percent !== 10 || !/^FAVORIS10-[A-F0-9]{20}$/.test(result.code || '')) return;
      offer.querySelector('[data-favorites-offer-code]').textContent = result.code;
      const returnUrl = new URL(window.location.href); returnUrl.searchParams.set('favorites_offer', '1');
      offer.querySelector('[data-favorites-offer-apply]').href = '/discount/' + encodeURIComponent(result.code) + '?redirect=' + encodeURIComponent(returnUrl.pathname + returnUrl.search);
      ready = true; offer.hidden = false;
      timer = setTimeout(showReminder, 5000);
    } catch (_) { /* Favorites continue working when the offer service is unavailable. */ }
  }
  function schedule() {
    hide(); ++requestVersion; clearTimeout(timer);
    timer = setTimeout(check, 2500);
  }
  document.addEventListener('wonderbook:favorites-change', schedule);
  document.addEventListener('wonderbook:favorites-open', () => { popup.hidden = true; schedule(); });
  window.addEventListener('pageshow', schedule);
  window.addEventListener('storage', event => { if (event.key === key || event.key?.startsWith('wonderbook:favorites:v1:')) schedule(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[data-favorites-offer-dismiss]')) popup.hidden = true;
    if (event.target.closest('[data-favorites-offer-view]')) { popup.hidden = true; window.WonderbookFavorites.open(); }
  });
  const returned = new URL(window.location.href);
  if (returned.searchParams.get('favorites_offer') === '1') {
    returned.searchParams.delete('favorites_offer'); window.history.replaceState(null, '', returned.pathname + returned.search + returned.hash);
    window.WonderbookFavorites.open();
  }
  schedule();
})();
